import { render, staticRenderFns } from "./swiperServicesMiddle.vue?vue&type=template&id=33d4f42f&"
import script from "./swiperServicesMiddle.vue?vue&type=script&lang=js&"
export * from "./swiperServicesMiddle.vue?vue&type=script&lang=js&"
import style0 from "./swiperServicesMiddle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d4f42f')) {
      api.createRecord('33d4f42f', component.options)
    } else {
      api.reload('33d4f42f', component.options)
    }
    module.hot.accept("./swiperServicesMiddle.vue?vue&type=template&id=33d4f42f&", function () {
      api.rerender('33d4f42f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiperServicesMiddle/swiperServicesMiddle.vue"
export default component.exports